import {format} from 'date-fns'

export function dateFilter(value:string|number|Date):string|undefined {    
    return formatter({
        value,
        time: false
    })
}

export function dateFromStringFilter(value:string):string|undefined {    
    if (!value) {
        return undefined
    }

    value = value.replace(/T.+/, '')

    const year = value.split('-')[0]
    const month = value.split('-')[1]
    const day = value.split('-')[2]

    return `${day}/${month}/${year}`
}

export function dateTimeFilter(value:string|number|Date):string|undefined {
    return formatter({
        value,
        time: true,
    })
}

function formatter(cfg:IConfigDateFormat):string|undefined {
    const valueIsDate = cfg.value instanceof Date
    const valueNeedsDateWrapper = typeof cfg.value === "string" || 
                             typeof cfg.value === "number"

    if (valueIsDate) {
        if (cfg.time) {
            return format(cfg.value as Date, 'dd/MM/yyyy HH:mm:ss');
        }

        return format(cfg.value as Date, 'dd/MM/yyyy');
    }

    if (valueNeedsDateWrapper) {
        if (cfg.time) {
            return format(new Date(cfg.value), 'dd/MM/yyyy HH:mm:ss');
        }

        return format(new Date(cfg.value), 'dd/MM/yyyy');
    }

    return undefined;   
}

interface IConfigDateFormat {
    value:string|number|Date,
    time:boolean,
}
